import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function PlayItOutArrangePage() {
  const [gallery, setGallery] = useState('');
  const [crossExam, setCrossExam] = useState('');
  const [reflections, setReflections] = useState('');

  return (
    <TaskPage
      phase="arrange"
      title="Play It Out (Gallery Walk)"
      pageNumber={7}
      instruction="Create a quick gallery: each person posts one item they advocate for with its score or bucket and 1-line why. Story: partners cross-examine each other's picks (what trade-off are you accepting?). Reflect (team): what patterns emerged? Does the shortlist still feel balanced?"
      whyItMatters="The build → story → reflect cycle boosts engagement and durable insight without heavy facilitation overhead."
      coachRail={{
        timing: "10-15 minutes",
        tips: "Use physical or digital cards. Each person advocates for one item.",
        debrief: "What patterns emerged? Does the shortlist still feel balanced?"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Build: Gallery (3-5 min)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Each person posts one item they advocate for with its score or bucket and 1-line why.</p>
          <TextArea
            label="Gallery items"
            value={gallery}
            onChange={(e) => setGallery(e.target.value)}
            placeholder="List the items people advocated for and why..."
            rows={6}
          />
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Story: Cross-Examine (Pairs)</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">Partners cross-examine each other's picks: what trade-off are you accepting?</p>
          <TextArea
            label="Trade-offs identified"
            value={crossExam}
            onChange={(e) => setCrossExam(e.target.value)}
            placeholder="What trade-offs did you discover? What are people accepting?"
            rows={5}
          />
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">Reflect: Patterns & Balance (Team)</h3>
          <p className="text-sm text-[var(--green)] dark:text-[var(--text-ter)] mb-4">What patterns emerged? Does the shortlist still feel balanced?</p>
          <TextArea
            label="Reflection notes"
            value={reflections}
            onChange={(e) => setReflections(e.target.value)}
            placeholder="What patterns did we see? Is the shortlist balanced? What should we adjust?"
            rows={5}
          />
        </div>

        <Callout type="tip" phase="arrange">
          <p className="text-sm">Use physical or digital cards to create a visual gallery. This helps everyone see the full picture.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






